
import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  Box,
  Button,
  Typography,
  Stack,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { toDate } from "../../../utils/monitoring-helpers";
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "8px",
};

const DateRangePicker = ({
  activeTarget,
  handleChange,
  isHomePage,
  endDate,
  setEndDate,
  startDate,
  setStartDate = () => { },
  handleClickShow,
  setCustomDatesToDisplay,
  availableDates = [], // MM-DD-YYYY format
}) => {
  const navLinksRef = useRef({});
  const [open, setOpen] = useState(false);
  const [isManualChange, setIsManualChange] = useState(false)

  const style = {
    width: isHomePage ? "220px" : "280px",
    height: isHomePage ? "35px" : null,
  };

  // Sort dates from recent to old
  const sortedDates = [...availableDates].sort(
    (a, b) => toDate(b) - toDate(a)
  );

  const mostRecentDate = sortedDates[0];
  const baselineDates = sortedDates.slice(1);

  // Auto-select defaults when modal opens
  useEffect(() => {
    if (isHomePage) return;
    if (mostRecentDate) setEndDate(mostRecentDate);
    if (baselineDates.length > 0) {
      setStartDate(baselineDates[0]);
    } else {
      setStartDate(mostRecentDate);
    }

  }, [JSON.stringify(availableDates)]);

  const handleClick = (event) => {
    event.preventDefault();
    const target = event.currentTarget.getAttribute("data-target");

    handleChange(target);
    Object.values(navLinksRef.current).forEach((link) =>
      link.classList.remove("active")
    );
    if (navLinksRef.current[target])
      navLinksRef.current[target].classList.add("active");

    if (isHomePage) return;

    if (target === "Custom") {
      if (!endDate && mostRecentDate) setEndDate(mostRecentDate);
      if (!startDate && baselineDates.length > 0)
        setStartDate(baselineDates[0]);
      setOpen(true);
    } else {
      setStartDate(null);
      setEndDate(null);
    }
  };

  useEffect(() => {
    if (startDate && endDate && !isManualChange) {
      setOpen(false);
      setCustomDatesToDisplay({ startDate, endDate })
      handleClickShow();
    }
  }, [startDate, endDate])


  const handleCustomSubmit = () => {
    if (startDate && endDate) {
      setCustomDatesToDisplay({ startDate, endDate })
      handleClickShow();
      setOpen(false);
      setIsManualChange(false)
    } else {
      alert("Please select both start and end dates.");
    }
  };

  return (
    <>
      <div
        style={style}
        className="mb-3 d-flex justify-content-between align-items-center"
      >
        <div className="dmqGroup">
          <button
            className={`${activeTarget === "Current" ? "active" : ""}`}
            data-target="Current"
            ref={(el) => (navLinksRef.current["Current"] = el)}
            onClick={handleClick}
          >
            Current
          </button>
{/* 
          <button
            className={`${activeTarget === "Month" ? "active" : ""}`}
            data-target="Month"
            ref={(el) => (navLinksRef.current["Month"] = el)}
            onClick={handleClick}
          >
            Month
          </button>

          <button
            className={`${activeTarget === "3Month" ? "active" : ""}`}
            data-target="3Month"
            ref={(el) => (navLinksRef.current["3Month"] = el)}
            onClick={handleClick}
          >
            3Month
          </button> */}

          {!isHomePage && (
            <button
              className={`${activeTarget === "Custom" ? "active" : ""}`}
              data-target="Custom"
              ref={(el) => (navLinksRef.current["Custom"] = el)}
              onClick={handleClick}
            >
              Custom
            </button>
          )}
        </div>
      </div>

      <Modal open={open && availableDates?.length>0} onClose={() => { }}
        disableEscapeKeyDown>
        <Box sx={modalStyle}>
          <IconButton
            onClick={() => { setIsManualChange(false); setOpen(false) }}
            sx={{ position: 'absolute', top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" mb={2}>
            Select Custom Dates
          </Typography>

          <Stack spacing={2}>
            {/* Recent Monitoring Date */}
            <FormControl fullWidth>
              <InputLabel id="start-label">Recent Monitoring Date</InputLabel>
              <Select
                labelId="start-label"
                value={endDate || ""}
                label="Recent Monitoring Date"
                onChange={(e) => {
                  const selectedEnd = e.target.value;
                  if (
                    startDate &&
                    toDate(selectedEnd) < toDate(startDate)
                  ) {
                    alert(
                      "Recent Monitoring Date must be later than or equal to the Baseline Monitoring Date."
                    );
                    return;
                  }
                  setIsManualChange(true)
                  setEndDate(selectedEnd);
                }}
              >

                {sortedDates?.length > 0 && sortedDates.map((date) => (
                  <MenuItem key={date} value={date}>
                    {date}
                  </MenuItem>
                ))}

                {/* {mostRecentDate && (
                  <MenuItem key={mostRecentDate} value={mostRecentDate}>
                    {mostRecentDate}
                  </MenuItem>
                )} */}
              </Select>
            </FormControl>

            {/* Baseline Monitoring Date */}
            <FormControl fullWidth>
              <InputLabel id="end-label">Baseline Monitoring Date</InputLabel>
              <Select
                labelId="end-label"
                value={startDate || ""}
                label="Baseline Monitoring Date"
                onChange={(e) => {
                  const selectedStart = e.target.value;
                  if (
                    endDate &&
                    toDate(selectedStart) > toDate(endDate)
                  ) {
                    alert(
                      "Baseline Monitoring Date must be earlier than or equal to the Recent Monitoring Date."
                    );
                    return;
                  }
                  setIsManualChange(true)
                  setStartDate(selectedStart);
                }}
              >

                {sortedDates?.length > 0 && sortedDates.map((date) => (
                  <MenuItem key={date} value={date}>
                    {date}
                  </MenuItem>
                ))}

                {/* {baselineDates?.length > 0 ? baselineDates.map((date) => (
                  <MenuItem key={date} value={date}>
                    {date}
                  </MenuItem>
                )) : <MenuItem key={mostRecentDate} value={mostRecentDate}>
                  {mostRecentDate}
                </MenuItem>} */}
                {/* {baselineDates.map((date) => (
                  <MenuItem key={date} value={date}>
                    {date}
                  </MenuItem>
                ))} */}
              </Select>
            </FormControl>

            <Button
              variant="contained"
              color="primary"
              onClick={handleCustomSubmit}
              disabled={!startDate || !endDate}
            >
              Apply
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default DateRangePicker;

